export default "/fonts/vendor/mdui/dist/roboto/Roboto-BlackItalic.woff2?6d1acccbf11ac5f449b88b037ff46165";